<template>
  <div class="login">
    <div class="login__container">
      <img src="/static/images/logo.png" alt="Logotipo CMS" class="login__logo">
      <h1 class="login__title">Acceso a usuarios</h1>
      <form class="form" @submit.prevent="login">
        <div class="form__fieldset">
          <div class="form__container">
            <label for="email" class="form__label form__label--hidden">Correo Electrónico</label>
            <input type="text" class="form__input" name="email" id="email" v-model="access.email" placeholder="Correo electrónico" v-validate="validation.email">
            <span v-show="errors.has('email')" class="form__alert" v-text="errors.first('email')"></span>
          </div>
          <div class="form__container">
            <label for="password" class="form__label form__label--hidden">Contraseña</label>
            <input type="password" class="form__input" name="password" id="password" v-model="access.password" placeholder="Contraseña" v-validate="validation.password">
            <span v-show="errors.has('password')" class="form__alert" v-text="errors.first('password')"></span>
          </div>
        </div>
        <input type="submit" class="btn btn__action btn--regular" value="Ingresar">
        <router-link :to="{name: 'recoveryLogin'}" class="btn btn__transparent btn--regular">¿Olvidó su contraseña?</router-link>
      </form>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import {auth} from '@/core/libs/sessions'
export default {
  name: 'signIn',
  mixins: [
    httpService
  ],
  data: function () {
    return {
      access: {
        email: null,
        password: null
      },
      validation: {
        email: 'required|email',
        password: 'required|min:6'
      }
    }
  },
  methods: {
    login: function () {
      this.$validator.validateAll()
        .then(
          result => {
            if (result) {
              let httpRequest = {
                params: '',
                module: 'login',
                element: this.access
              }
              this.post(httpRequest)
                .then(
                  login => {
                    auth.setSession(login)
                      .then(
                        response => {
                          this.$store.commit('login', true)
                          this.$router.push({name: 'home'})
                        }
                      )
                  }
                ).catch(
                  () => {
                    this.$store.commit('notificate', {
                      title: 'ERROR DE INICIO DE SESIÓN',
                      text: 'Por favor revise los datos ingresados, no pudimos validar su usuario y contraseña',
                      type: 'warn'
                    })
                  }
                )
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/components/_login"
@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/login/signin.vue